import * as React from 'react'

import { IItem } from '../../../../typings/searchResults'
import ImagePreview from '../../../components/imagePreview'
import ImagePreviewWithCarousel from '../../../components/imagePreviewWithCarousel'
import ImagePlaceholder from '../../imagePlaceholder'

interface IProps {
  item: IItem
  onItemLinkClick: React.EventHandler<any>
  carousel?: boolean
}

const Preview = ({ item, onItemLinkClick, carousel = false }: IProps) => {
  const previewWithCarousel = (
    <ImagePreviewWithCarousel item={item} onItemLinkClick={onItemLinkClick} />
  )

  const previewWithoutCarousel = (
    <a href={item.url} onClick={onItemLinkClick}>
      <ImagePlaceholder ratio={0.5}>
        <ImagePreview item={item} />
      </ImagePlaceholder>
    </a>
  )

  return carousel ? previewWithCarousel : previewWithoutCarousel
}

export default Preview
